import { render } from "./DocumentsOption.vue?vue&type=template&id=4e307ec3&scoped=true"
import script from "./DocumentsOption.vue?vue&type=script&lang=js"
export * from "./DocumentsOption.vue?vue&type=script&lang=js"

import "./DocumentsOption.vue?vue&type=style&index=0&id=4e307ec3&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e307ec3"]])

export default __exports__